/*Shadow*/
export const shadows = {
  imageShadow: 'drop-shadow(5px 15px 50px rgba(0, 0, 0, 0.08))',
  productImageShadow: 'drop-shadow(2px 5px 40px rgba(0, 0, 0, 0.07))',
};
